/** Top-right cluster: theme + language (and optional children) */
export function Toolbar({ children, className = '' }) {
  return (
    <div className={`flex flex-wrap items-center justify-end gap-2 ${className}`}>
      {children}
    </div>
  );
}
